enum LAYOUT_TYPES {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal"
}

enum LAYOUT_SEMI_DARK {
  LIGHT = "light",
  DARK = "dark",
}

enum LAYOUT_SKIN {
  DEFAULT = "default",
  BORDERED = "bordered",
}

enum LAYOUT_MODE_TYPES {
  LIGHTMODE = "light",
  DARKMODE = "dark",
}

enum LAYOUT_DIRECTION {
  LTR = "ltr",
  RTL = "rtl",
}

enum LAYOUT_CONTENT_WIDTH {
  FLUID = "fluid",
  BOXED = "boxed",
}

enum LEFT_SIDEBAR_SIZE_TYPES {
  DEFAULT = "lg",
  COMPACT = "md",
  SMALLICON = "sm"
}

enum LEFT_NAVIGATION_TYPES {
  STICKY = "sticky",
  SCROLL = "scroll",
  BORDERED = "bordered",
  HIDDEN = "hidden",
}

enum LEFT_SIDEBAR_COLOR_TYPES {
  LIGHT = "light",
  DARK = "dark",
  BRAND = "brand",
  MODERN = "modern"
}

enum LAYOUT_TOPBAR_THEME_TYPES {
  LIGHT = "light",
  DARK = "dark",
  BRAND = "brand"
}

export {
  LAYOUT_TYPES,
  LAYOUT_SEMI_DARK,
  LAYOUT_SKIN,
  LAYOUT_MODE_TYPES,
  LAYOUT_DIRECTION,
  LAYOUT_CONTENT_WIDTH,
  LEFT_SIDEBAR_SIZE_TYPES,
  LEFT_NAVIGATION_TYPES,
  LEFT_SIDEBAR_COLOR_TYPES,
  LAYOUT_TOPBAR_THEME_TYPES
};
